// extracted by mini-css-extract-plugin
export default {"tag-wrapper":"PZlsFdZxxiV2NumrEZvB","tagWrapper":"PZlsFdZxxiV2NumrEZvB","tag":"fCRVDPYoYAefEY2qG2wQ","clickable":"YSmZs1gk7lbgrh_jPu1y"};